import { bdcDashboardReducer, BdcDashboardState } from './bdcdashboard/bdcdashboard.reducer';
import { EmployeeState, employeeReducer } from './employee/employee.reducer';
import { HolidayState, holidayReducer } from './holiday/holiday.reducer';
import { ActionReducerMap, Action } from '@ngrx/store';
import { CapacityState, capacityReducer } from './capacity/capacity.reducer';
import { teamsReducer, TeamState } from './team/team.reducer';
import { SlotState, slotReducer } from './slot/slot.reducer';
import { salesAvailabilityReducer, SalesAvailabilityState } from './sales-availability/sales-availability.reducer';
import { SettingsState, settingsReducer } from './settings/settings.reducer';
import { OpCodeState, opCodeReducer } from './opcode/opcode.reducer';
import { SalesAppointmentState, salesAppointmentReducer } from './sales-appointment/sales-appointment.reducer';
import { PartsAppointmentState, partsAppointmentReducer } from './parts-appointment/parts-appointment.reducer';
import {serviceAppointmentReducer, ServiceAppointmentState} from './service-appointment/service-appointment.reducer';
import { searchCustomersReducer, SearchCustomersState } from './search-customers/search-customers.reducer';
import { DealerState, dealerReducer } from './dealer/dealer.reducer';
import {scheduleRotationReducer, ScheduleRotationState} from './schedule-rotation/schedule-rotation.reducer';
import { scheduleDashboardReducer, ScheduleDashboardState } from './schedule-dashboard/schedule-dashboard.reducer';
import { VehiclesState, vehiclesReducer} from './vehicle/vehicle.reducer';
import { ChecklistState, checklistReducer} from './checklist/checklist.reducer';
import { deliveryChecklistReducer, DeliveryChecklistState } from './delivery-checklist/delivery-checklist.reducer';
import { CorporateDashboardState, corporateDashboardReducer } from './corporate-dashboard/corporate-dashboard.reducer';

/* Feature keys */
export enum FeatureKeys {
  EMPLOYEES = 'employeeState',
  HOLIDAYS = 'holidayState',
  CAPACITY = 'capacityState',
  TEAMS = 'teamsState',
  SLOT = 'slotState',
  SETTINGS = 'settingsState',
  SALES_AVAILABILITY = 'salesAvailabilityState',
  OPCODE = 'opCodeState',
  SALES_APPOINTMENT = 'salesAppointmentState',
  PARTS_APPOINTMENT = 'partsAppointmentState',
  SERVICE_APPOINTMENT = 'serviceAppointmentState',
  SEARCH_CUSTOMERS = 'searchCustomersState',
  BDCDASHBOARD = 'bdcDashboardState',
  DEALER = 'dealerState',
  SCHEDULE_ROTATION = 'scheduleRotation',
  SCHEDULE_DASHBOARD = 'scheduleDashboard',
  VEHICLES = 'vehiclesState',
  CHECKLIST = 'checklistState',
  DELIVERY_CHECKLIST = 'deliveryChecklistState',
  CORPORATE_DASHBOARD = 'corporateDashboardState'
}

/* App Reducer */
export interface AppState {
  [FeatureKeys.EMPLOYEES]: EmployeeState,
  [FeatureKeys.HOLIDAYS]: HolidayState,
  [FeatureKeys.CAPACITY]: CapacityState,
  [FeatureKeys.TEAMS]: TeamState,
  [FeatureKeys.SLOT]: SlotState,
  [FeatureKeys.SETTINGS]: SettingsState,
  [FeatureKeys.SALES_AVAILABILITY]: SalesAvailabilityState,
  [FeatureKeys.OPCODE]: OpCodeState,
  [FeatureKeys.SALES_APPOINTMENT]: SalesAppointmentState,
  [FeatureKeys.PARTS_APPOINTMENT]: PartsAppointmentState,
  [FeatureKeys.SERVICE_APPOINTMENT]: ServiceAppointmentState,
  [FeatureKeys.SEARCH_CUSTOMERS]: SearchCustomersState,
  [FeatureKeys.BDCDASHBOARD]: BdcDashboardState,
  [FeatureKeys.DEALER]: DealerState,
  [FeatureKeys.SCHEDULE_ROTATION]: ScheduleRotationState,
  [FeatureKeys.SCHEDULE_DASHBOARD]: ScheduleDashboardState,
  [FeatureKeys.VEHICLES]: VehiclesState,
  [FeatureKeys.CHECKLIST]: ChecklistState,
  [FeatureKeys.DELIVERY_CHECKLIST] : DeliveryChecklistState,
  [FeatureKeys.CORPORATE_DASHBOARD]: CorporateDashboardState
}

export const appReducer: ActionReducerMap<AppState> = {
  employeeState: employeeReducer,
  capacityState: capacityReducer,
  holidayState: holidayReducer,
  teamsState: teamsReducer,
  slotState: slotReducer,
  settingsState: settingsReducer,
  salesAvailabilityState: salesAvailabilityReducer,
  opCodeState: opCodeReducer,
  salesAppointmentState: salesAppointmentReducer,
  partsAppointmentState: partsAppointmentReducer,
  serviceAppointmentState: serviceAppointmentReducer,
  searchCustomersState: searchCustomersReducer,
  bdcDashboardState: bdcDashboardReducer,
  dealerState: dealerReducer,
  scheduleRotation: scheduleRotationReducer,
  scheduleDashboard: scheduleDashboardReducer,
  vehiclesState : vehiclesReducer,
  checklistState: checklistReducer,
  deliveryChecklistState: deliveryChecklistReducer,
  corporateDashboardState: corporateDashboardReducer
};

/* Actions */
export enum AppStoreTypes {
  START_APP_INITIALIZER = '[AppStore] Start App Initializer',
  FINISH_APP_INITIALIZER = '[AppStore] Finish App Initializer',
}

export class StartAppInitializer implements Action {
  public readonly type = AppStoreTypes.START_APP_INITIALIZER;
}

export class FinishAppInitializer implements Action {
  public readonly type = AppStoreTypes.FINISH_APP_INITIALIZER;

  constructor(public payload: { success: boolean } = {success: true}) {
  }
}

export type AppActions = StartAppInitializer | FinishAppInitializer;
